import axios from "axios";
import React, { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next";

function ServicesSection(props) {
    const { t, i18n } = useTranslation('common');
    let rem_services = props?.MetaData?.rem_services
    if (rem_services != undefined) {
        try {
            rem_services = JSON.parse(rem_services)
        } catch (e) {
        }
    }
    const [serviceData, setServiceData] = useState(rem_services);

    let rem_more_info = props?.MetaData?.rem_more_info
    if (rem_more_info != undefined) {
        try {
            rem_more_info = JSON.parse(rem_more_info)
        } catch (e) {
        }
    }
    const [text_no_Data, setText_no_Data] = useState(rem_more_info);

    function set_url(path) {
        return props?.site_url+path;
    }

    return (<section class={(props?.MetaData?.rem_service_enable?.[0] == 'Yes') ? "Services_main_section rem_nav_section" : 'Services_main_section'} id="services_section">
        {
         
            (props?.MetaData?.rem_service_enable?.[0] == 'Yes') &&
            (<div class="container_size">
                <h3 class="services_description_heading">{t('Services Description')}</h3>
                <div class="Services-main">
                    <div class="Services-list">
                        {(serviceData?.services?.services_1) ?
                            <ul>
                                <li><h5>{(props?.MetaData?.service_1_text?.[0]) ? props?.MetaData?.service_1_text?.[0] : ''} </h5></li>
                                {serviceData?.services?.services_1.map(function (service, i) {
                                    return (<li>
                                        <img src={set_url("/wp-content/uploads/images/noun-check.svg")} alt="" />
                                        {service}
                                    </li>);
                                })}
                            </ul>
                            : ''}
                    </div>
                    <div class="Services-list">
                        {(serviceData?.services?.services_2) ?
                            <ul>
                                
                                <li><h5>{(props?.MetaData?.service_2_text?.[0]) ? props?.MetaData?.service_2_text?.[0] : ''}</h5></li>
                                {serviceData?.services?.services_2.map(function (service, i) {
                                    return (<li>
                                        <img src={set_url("/wp-content/uploads/images/noun-check.svg")} alt="" />
                                        {service}
                                    </li>);
                                })}
                            </ul>
                        : ''} 
                    </div>
                </div>
            </div>)
        }
        {(props?.MetaData?.rem_custom_txt_enable?.[0] == 'Yes') && (
            <section class="member-section project_details_section">
                <div class="container_size">
                    <ul class="project_details_rem">
                        <li class="member-id">
                            <div>
                                {(text_no_Data?.custom_number_text?.custom_number_1) ? <h1 class="project-number">{text_no_Data?.custom_number_text?.custom_number_1}</h1> : ''}
                                {(text_no_Data?.custom_number_text?.custom_text_1) ? <p>{text_no_Data?.custom_number_text?.custom_text_1}</p> : ''}
                            </div>
                        </li>

                        <li class="member-id">
                            <div>
                                {(text_no_Data?.custom_number_text_1?.custom_number_2) ? <h1 class="project-number">{text_no_Data?.custom_number_text_1?.custom_number_2}</h1> : ''}
                                {(text_no_Data?.custom_number_text_1?.custom_text_2) ? <p>{text_no_Data?.custom_number_text_1?.custom_text_2}</p> : ''}
                            </div>
                        </li>

                        <li class="member-id">
                            <div>
                                {(text_no_Data?.custom_number_text_2?.custom_number_3) ? <h1 class="project-number">{text_no_Data?.custom_number_text_2?.custom_number_3}</h1> : ''}
                                {(text_no_Data?.custom_number_text_2?.custom_text_3) ? <p>{text_no_Data?.custom_number_text_2?.custom_text_3}</p> : ''}
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        )}
    </section>);
}

export default ServicesSection;